angular.module('dashboard', ['core', 'document', 'clients', 'tasks'])
    .factory('DashboardSwitcher', function ($cookies, Principal) {
        let DASHBOARD_COOKIE = "dashboard-layout"

        function getDashboards() {
            let dashboards = []
            const hasTaskAccess = Principal.hasAnyAuthority(["ROLE_TASKS"])
            const hasInvoiceAccess = Principal.hasAnyAuthority(["ROLE_INVOICE_DOCUMENTS_MODULE"])
            const hasManufacturingDashboardAccess = Principal.hasAnyAuthority(["ROLE_MANUFACTURING_ORDER_MANAGEMENT"])

            if (hasTaskAccess || hasInvoiceAccess || hasManufacturingDashboardAccess) {
                dashboards.push({
                    id: 1,
                    name: "Pulpit podstawowy",
                    template: "app/dashboard/dashboard-standard.tpl.html"
                })
            }
            if (hasTaskAccess) {
                dashboards.push({
                    id: 2,
                    name: "Pulpit rozszerzony kalendarz",
                    template: "app/dashboard/dashboard-extended-calendar.tpl.html"
                })
            }
            if (Principal.hasAnyAuthority(["ROLE_VEHICLE_BOOKING"])) {
                dashboards.push({
                    id: 3,
                    name: "Pulpit rezerwacje pojazdów",
                    template: "app/dashboard/dashboard-vehicles.tpl.html"
                })
            }
            return dashboards
        }

        return {
            getTemplate: () => {
                let dashboardId = $cookies.getObject(DASHBOARD_COOKIE);
                let dashboard = getDashboards().find(x => x.id === dashboardId) || getDashboards().find(x => x !== undefined)
                return dashboard!=null? dashboard.template : null
            },
            setTemplate: dash => {
                $cookies.putObject(DASHBOARD_COOKIE, dash.id)
            },
            dashboards: () => {
                return getDashboards()
            }
        }
    })
    .controller('DashboardController', function ($scope, $rootScope, $interval, Principal, toastr, Task, TaskService, ClientService, Client, Note, NoteService, Document, DocumentFilterService, Priority, DashboardSwitcher) {

        $scope.filters = DocumentFilterService.filters
        $scope.TaskService = TaskService
        $scope.NoteService = NoteService

        let intervalPromise

        $scope.$on('authenticationChanged', () => initAutoRefresh())

        $scope.isAuthenticated = () => Principal.isAuthenticated()

        $scope.$watch(() => Principal.isIdentityResolved(), principalResolved => {
            if (principalResolved)
                initAutoRefresh()
            else
                $interval.cancel(intervalPromise)
        })

        function initAutoRefresh() {
            $interval.cancel(intervalPromise);
            if (!hasTaskDashboardAccess()) {
                return
            }

            loadTasks()
            loadNotes()
            loadComments()

            intervalPromise = $interval(initAutoRefresh, 60000)
        }

        $scope.$on('$destroy', () => $interval.cancel(intervalPromise))

        function hasTaskDashboardAccess() {
            return Principal.hasAnyAuthority(["ROLE_TASKS"])
        }

        function sequence(tasks, fn) {
            return tasks.reduce((promise, task) => promise.then(() => fn(task)), Promise.resolve());
        }

        function loadTasks() {
            if (!hasTaskDashboardAccess()) {
                return
            }
            let unplanned = {
                filter: "unplanned",
                sort: "createdTime,desc"
            }
            angular.extend(unplanned, $scope.filters)
            let forToday = {
                filter: "for-today",
                sort: "endTime,asc"
            }
            angular.extend(forToday, $scope.filters)
            let overdue = {
                filter: "overdue",
                sort: "endTime,desc"
            }
            angular.extend(overdue, $scope.filters);
            let upcoming = {
                filter: "upcoming",
                sort: "endTime,asc"
            }
            angular.extend(upcoming, $scope.filters)
            let done = {
                filter: "done-last-7days",
                sort: "realEndTime,desc",
                forMe: true,
                managedByMe: true,
                subscribed: true
            }

            let unplannedPromise = Task.myTodo(unplanned).$promise.then(result => $scope.unplannedTasks = result.list)
            let forTodayPromise = Task.myTodo(forToday).$promise.then(result => $scope.tasksForToday = result.list)
            let overduePromise = Task.myTodo(overdue).$promise.then(result => $scope.overdueTasks = result.list)
            let upcomingPromise = Task.myTodo(upcoming).$promise.then(result => $scope.upcomingTasks = result.list)
            let donePromise = Task.myTodo(done).$promise.then(myTasksDone => {
                $scope.doneLast7days = myTasksDone.list
                let todayStart = moment().local().startOf('day')
                let yesterdayStart = moment().local().subtract(1, 'days').startOf('day')

                $scope.doneToday = myTasksDone.list.filter(item => moment(item.realEndTime).isAfter(todayStart))
                $scope.doneYesterday = myTasksDone.list.filter(item => moment(item.realEndTime).isAfter(yesterdayStart) && moment(item.realEndTime).isBefore(todayStart))
            })

            sequence([unplannedPromise, forTodayPromise, overduePromise, upcomingPromise, donePromise], (result) => {

            }).then(() => {

            })
        }

        function loadNotes() {
            if (!hasTaskDashboardAccess() || !Principal.hasAnyAuthority(['ROLE_NOTES'])) {
                return
            }
            Note.table({filter: "last-7-days", sort: "createdTime,desc"}).$promise
                .then(notes_last7d => {
                    $scope.notesLast7days = notes_last7d.list;
                    let todayStart = moment().local().startOf('day');
                    let yesterdayStart = moment().local().subtract(1, 'days').startOf('day');
                    $scope.notesToday = notes_last7d.list.filter(item => moment(item.audit.createdTime).isAfter(todayStart));
                    $scope.notesYesterday = notes_last7d.list.filter(item => moment(item.audit.createdTime).isAfter(yesterdayStart) && moment(item.audit.createdTime).isBefore(todayStart));
                });
        }

        function loadComments() {
            if (!hasTaskDashboardAccess()) {
                return
            }
            Document.lastComments().$promise.then(comments_last7d => {
                let todayStart = moment().local().startOf('day');
                let yesterdayStart = moment().local().subtract(1, 'days').startOf('day');
                $scope.commentsToday = comments_last7d.list.filter(item => moment(item.createdTime).isAfter(todayStart));
                $scope.commentsYesterday = comments_last7d.list.filter(item => moment(item.createdTime).isAfter(yesterdayStart) && moment(item.createdTime).isBefore(todayStart));
                $scope.commentsLast7days = comments_last7d.list;
            });
        }

        $scope.$on('file.saved', () => {
            loadTasks()
            loadComments()
        });
        $scope.$on('task.updated', () => {
            loadTasks()
            loadComments()
        });
        $scope.$on('task.deleted', () => {
            loadTasks()
            loadComments()
        });
        $scope.$on('note.updated', () => loadNotes())
        $scope.$on('note.deleted', () => loadNotes())

        $scope.$watch('filters', (newValue, oldValue) => {
            if (newValue !== oldValue) {
                loadTasks();
            }
        }, true)

        $scope.getDashboardTemplate = () => DashboardSwitcher.getTemplate()
    })
    .component('homeComponent', {
        templateUrl: 'app/dashboard/dashboard.tpl.html',
        controller: 'DashboardController'
    })
    .config(function ($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': 'homeComponent'
            }
        })
    })
